import React from "react";

const MAP = {
  open: { label: "Open", cls: "bg-[#E0E7FF] text-[#002FA7]" },
  negotiating: { label: "Negotiating", cls: "bg-[#FEF3C7] text-[#B45309]" },
  contracted: { label: "Contracted", cls: "bg-[#D1FAE5] text-[#047857]" },
  closed: { label: "Closed", cls: "bg-[#F3F4F6] text-[#4B5563]" },
  draft: { label: "Draft", cls: "bg-[#F3F4F6] text-[#4B5563]" },
  sent: { label: "Sent", cls: "bg-[#E0E7FF] text-[#002FA7]" },
  accepted: { label: "Accepted", cls: "bg-[#D1FAE5] text-[#047857]" },
  declined: { label: "Declined", cls: "bg-[#FEE2E2] text-[#B91C1C]" },
  confirmed: { label: "Confirmed", cls: "bg-[#D1FAE5] text-[#047857]" },
  cancelled: { label: "Cancelled", cls: "bg-[#FEE2E2] text-[#B91C1C]" },
  new: { label: "New", cls: "bg-[#E0E7FF] text-[#002FA7]" },
  contacted: { label: "Contacted", cls: "bg-[#FEF3C7] text-[#B45309]" },
  qualified: { label: "Qualified", cls: "bg-[#DBEAFE] text-[#1D4ED8]" },
  proposal: { label: "Proposal Sent", cls: "bg-[#EDE9FE] text-[#6D28D9]" },
  won: { label: "Won", cls: "bg-[#D1FAE5] text-[#047857]" },
  lost: { label: "Lost", cls: "bg-[#FEE2E2] text-[#B91C1C]" },
};

export default function StatusBadge({ status, testid }) {
  const s = MAP[status] || { label: status, cls: "bg-[#F3F4F6] text-[#4B5563]" };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
